import React, { FunctionComponent } from "react";

import { useSearchWheelsByVehicle } from "../../../queries/useSearchWheelsByVehicle";
import { useProductModalHash } from "../ProductModal";
import { WheelDetails } from "./WheelDetails";

export const WheelModalContent: FunctionComponent = () => {
  const { data: results } = useSearchWheelsByVehicle();
  const { itemId } = useProductModalHash();

  const product = results?.allParts.find(
    ({ partDetails }) => partDetails.primaryPart.itemId === itemId
  );

  return <WheelDetails part={product || null} />;
};
